import React, { useState, useEffect, useRef } from "react";
import "./header.css";
import { FaUser, FaShoppingCart, FaBars, FaTimes } from "react-icons/fa";
import { Link ,useLocation} from "react-router-dom";
import { useCurrency } from "../Currencycontext";

const Header = ({loginTrigger }) => {
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);
  const { currency, setCurrency } = useCurrency();
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
  const [showMobileNav, setShowMobileNav] = useState(false);
  const [showMobileServices, setShowMobileServices] = useState(false);
  const accountRef = useRef(null);
  const mobileNavRef = useRef(null);
  const [config, setConfig] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const hideCurrency = location.pathname === "/cart" || location.pathname === "/checkout";


  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  // Check login status
  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.CHECK_SESSION}`, {
      method: "POST",
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (data.active) {
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
      })
      .catch(() => setIsLoggedIn(false));
  }, [config,loginTrigger]);

  // Fetch cart count from backend
  useEffect(() => {
    if (!config || !isLoggedIn) return;

    const fetchCartCount = () => {
      fetch(`${config.BASE_URL}${config.GET_CART}`, {
        method: "POST",
        credentials: "include",
      })
        .then(res => res.json())
        .then(data => {
          if (data.success && data.cart) {
            setCartCount(data.cart.length);
          }
        })
        .catch(err => console.error("Failed to fetch cart:", err));
    };

    fetchCartCount();

    window.addEventListener("cartUpdated", fetchCartCount);
    return () => window.removeEventListener("cartUpdated", fetchCartCount);
  }, [config, isLoggedIn]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setShowAccountDropdown(false);
      }
      if (mobileNavRef.current && !mobileNavRef.current.contains(event.target) && 
          !event.target.closest('.site-hamburger')) {
        setShowMobileNav(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="site-navbar">
      <div className="site-glassy-logo">
        <img src="/tm logo.png" alt="Logo" className="site-header-logo" />
      </div>

      {/* Desktop Navigation */}
      <nav className="site-navbar-center">
        <Link to="/" className="site-glassy-button">Home</Link>
        <Link to="/about" className="site-glassy-button">About</Link>
        <Link to="/products" className="site-glassy-button">Products</Link>
        <div className="site-dropdown-container">
          <Link to="#" className="site-glassy-button site-dropdown-toggle">
          Services <span className="site-dropdown-arrow">▼</span>
          </Link>
          <div className="site-dropdown-menu">
                    <a 
              href="https://edu.robocoupler.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="dropdown-item"
            >
            Edutech
            </a>
            <Link to="/pcb-design" className="site-dropdown-item">PCB Designing</Link>
            <Link to="/3dprinting" className="site-dropdown-item">3D Printing</Link>
            <Link to="/internships" className="site-dropdown-item">Internships</Link>
            <Link to='/project-list' className="dropdown-item">Project List</Link>
          </div>
        </div>
      </nav>

      {/* Desktop Icons */}
      <div className="site-header-right site-icons-container">
        {/* Account */}
        <div className="site-account-dropdown" ref={accountRef}>
          <div className="site-icon-tooltip" data-tooltip="Account">
            <button
              className="site-glassy-button site-icon-btn"
              onClick={() => setShowAccountDropdown(!showAccountDropdown)}
            >
              <FaUser />
            </button>
          </div>
          <div className={`site-account-dropdown-menu ${showAccountDropdown ? "show" : ""}`}>
            {isLoggedIn ? (
              <>
                <Link 
                  to="/account" 
                  className="site-account-dropdown-item" 
                  onClick={() => setShowAccountDropdown(false)}
                >
                  My Account
                </Link>
                <Link 
                  to="/myorders" 
                  className="site-account-dropdown-item"
                  onClick={() => setShowAccountDropdown(false)}
                >
                  My Orders
                </Link>
                <Link 
                  to="/wishlist" 
                  className="site-account-dropdown-item"
                  onClick={() => setShowAccountDropdown(false)}
                >
                  My Wishlist
                </Link>
              </>
            ) : (
              <Link 
                to="/login" 
                className="site-account-dropdown-item"
                onClick={() => setShowAccountDropdown(false)}
              >
                Login to check your account
              </Link>
            )}
          </div>
        </div>

        {/* Cart */}
        <div className="site-icon-tooltip" data-tooltip="Cart">
          <Link to="/cart" className="site-glassy-button site-icon-btn site-icon-link">
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            <FaShoppingCart />
          </Link>
        </div>

        {/* Currency Switcher */}
        {/* {!hideCurrency && (
          <div className="site-icon-tooltip" data-tooltip="Currency">
            <button className="site-glassy-button site-icon-btn" onClick={() => setCurrency(currency === "INR" ? "USD" : "INR")}>
              {currency === "INR" ? "₹" : "$"}
            </button>
          </div>
        )} */}
      </div>

      {/* Mobile Hamburger Menu */}
      <button
        className={`site-hamburger ${showMobileNav ? "active" : ""}`}
        onClick={() => setShowMobileNav(!showMobileNav)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Mobile Navigation */}
      <nav ref={mobileNavRef} className={`site-mobile-nav ${showMobileNav ? "show" : ""}`}>
        <Link to="/" className="site-glassy-button" onClick={() => setShowMobileNav(false)}>Home</Link>
        <Link to="/about" className="site-glassy-button" onClick={() => setShowMobileNav(false)}>About</Link>
        <Link to="/products" className="site-glassy-button" onClick={() => setShowMobileNav(false)}>Products</Link>
        
        {/* Mobile Services Dropdown */}
        <div className="site-mobile-dropdown">
          <button
            className="site-mobile-dropdown-toggle"
            onClick={() => setShowMobileServices(!showMobileServices)}
          >
            Services <span className="site-dropdown-arrow">{showMobileServices ? "▲" : "▼"}</span>
          </button>
          {showMobileServices && (
            <div className="site-mobile-dropdown-menu">
              <a href="https://edu.robocoupler.com/"  target="_blank" rel="noopener noreferrer"  className="site-dropdown-item" onClick={() => setShowMobileNav(false)}>Edutech</a>
              <Link to="/pcb-design" className="site-dropdown-item" onClick={() => setShowMobileNav(false)}>PCB Designing</Link>
              <a href="/3dprinting" className="site-dropdown-item" onClick={() => setShowMobileNav(false)}>3D Printing</a>
              <Link to="/internships" className="site-dropdown-item" onClick={() => setShowMobileNav(false)}>Internships</Link>
              <Link to="/project-list" className="site-dropdown-item" onClick={() => setShowMobileNav(false)}>Project List</Link>
            </div>
          )}
        </div>

        {/* Mobile Account Options */}
        {isLoggedIn ? (
          <>
            <Link to="/account" className="site-glassy-button" onClick={() => setShowMobileNav(false)}>My Account</Link>
            <Link to="/myorders" className="site-glassy-button" onClick={() => setShowMobileNav(false)}>My Orders</Link>
            <Link to="/wishlist" className="site-glassy-button" onClick={() => setShowMobileNav(false)}>My Wishlist</Link>
          </>
        ) : (
          <Link to="/" className="site-glassy-button" onClick={() => setShowMobileNav(false)}>Login</Link>
        )}
      </nav>
    </header>
  );
};

export default Header;